/**
* 功能: 报告列表的展示、搜索以及对报告的审核、删除
*/
<template lang="pug">
.content
  el-form.demo-form-inline(:inline='true' :model='findForm' :size='GLOBAL.SIZE_OF_INPUTBOX')
    el-row(:span='24')
      el-col(:md='7' :xl='5')
        el-form-item(label='报告标题')
          el-input(v-model='findForm.title' placeholder='请输入' clearable style='width:250px')
      el-col(:md='3' :xl='4')
        el-form-item
          el-button(type='text' :size='GLOBAL.SIZE_OF_INPUTBOX' @click='showMoreCondition') < {{ isShowConditionText }} >
      el-col(:md='9' :xl='9')
        el-form-item
          el-button-group
            el-button(type='primary' :size='GLOBAL.SIZE_OF_INPUTBOX' @click='search') 查询
            el-button(v-if="hasEditAuth" type='primary' :size='GLOBAL.SIZE_OF_INPUTBOX' @click='$router.push({ name: "EditReportBrief" })') 新建报告
            //- el-button(v-if="hasEditAuth" type='primary' :size='GLOBAL.SIZE_OF_INPUTBOX' @click='exportLabels') 导出标签
    el-row(:span='24' :class='isShowCondition ? "" : "hide"')
      el-row
        el-col(:md='8' :xl='7')
          el-form-item(label='创建日期')
            el-date-picker(style='width:280px' v-model='findForm.writtenDate' type='daterange' align='right' unlink-panels range-separator='-' start-placeholder='开始日期' end-placeholder='结束日期' :picker-options='pickerOptions')
        el-col(:md='8' :xl='7')
          el-form-item(label='行业')
            FrostIndustry(v-model='findForm.industryId' :isshow='false' v-on:industryId='industryId')
        el-col(:md='8' :xl='7')
          el-form-item(label='状态')
            el-select(v-model='findForm.status' multiple placeholder='请选择' style='width:190px')
              el-option(v-for='item in options' :key='item.value' :label='item.label' :value='item.value')
      el-row
        el-col(:md='8' :xl='7')
          el-form-item(label='类型')
            el-select(v-model='findForm.briefType' multiple placeholder='请选择' style='width:240px')
              el-option(v-for='item in briefType' :key='item.value' :label='item.label' :value='item.value')
        el-col(:md='8' :xl='7')
          el-form-item(label='显示')
            el-select(v-model='findForm.kind' placeholder='请选择')
              el-option(v-for='item in KIND' :key='item.value' :label='item.label' :value='item.value')
        //- el-col(:md='8' :xl='7')
        //-   el-form-item(label='PDF')
        //-     el-select(v-model='findForm.checkList' placeholder='请选择')
        //-       el-option(v-for='item in PDF' :key='item.value' :label='item.label' :value='item.value')
      el-row
        //- el-col(:md='8' :xl='6')
        //-   el-form-item(label='限免状态')
        //-     el-checkbox-group(v-model='findForm.freeStatus')
        //-       el-checkbox(label='isfree') 是
        //-       el-checkbox(label='nofree')  否
        el-col(:md='8' :xl='6')
          el-form-item(label='即将发布')
            el-checkbox-group(v-model='findForm.releasedStatus')
              el-checkbox(label='isreleased') 是
              el-checkbox(label='noreleased') 否

  el-table(:data='tableData' style='width: 100%' @sort-change='tableSortChange' :size='GLOBAL.SIZE_OF_INPUTBOX' v-loading='loading')
    el-table-column(label='内部编号' fixed prop='code' sortable='custom' width='100')
    el-table-column(prop='image' label='图' width='100' align='center' fixed)
      template(slot-scope='scope')
        img(v-if='scope.row.image' :src='scope.row.image' style='max-width:100px;max-height:40px;')
    el-table-column(label='标题' prop='title' sortable='custom' min-width='90')
      template(slot-scope='scope')
        p
          b {{ scope.row.briefType | formatBriefType }}
          //- b {{ scope.row.free ? ` [免] ` : " " }}
          b {{ scope.row.released ? `[即]` : " " }}
          //- b(v-if='scope.row.pdf')
          //-   span(style="color: #67C23A") [PDF]
          span {{ scope.row.title + " " }}
          <br />
          //- span(v-if='scope.row.industry' v-html='scope.row.industry.join("&nbsp&nbsp")')
    el-table-column(label='字符/页数' prop='total' sortable='custom' width='110')
      template(slot-scope='scope')
        span(v-if='scope.row.total !== -1 && scope.row.kind === 0') {{ scope.row.total }}字&nbsp;&nbsp;
        span(v-if='scope.row.total !== -1 && scope.row.kind === 1') {{ scope.row.total }}页&nbsp;&nbsp;
        el-button(v-if='scope.row.total !== -1' :size='GLOBAL.SIZE_OF_INPUTBOX' type='text' @click='totalCount(scope.row)') RE
        el-button(v-if='scope.row.total === -1' :size='GLOBAL.SIZE_OF_INPUTBOX' type='text' @click='totalCount(scope.row)') 获取
    el-table-column(label='状态' prop='status' sortable='custom' width='80')
      template(slot-scope='scope')
        p {{ scope.row.status | status }}
    el-table-column(label='版本' prop='version' width='100' align='center')
    el-table-column(label='限免次数' prop='freeCount' width='100' align='center' sortable='custom')
    el-table-column(label='编辑/作者' prop='createdByName' sortable='custom' width='120')
      template(slot-scope='scope')
        p {{ scope.row.createdByName }} {{ scope.row.author ? `/${scope.row.author}` : "/ 暂无" }}
    el-table-column(label='发布日期' prop='releaseDate' sortable='custom' width='100')
      template(slot-scope='scope')
        p {{ scope.row.releaseDate | changeData }}
    el-table-column(label='报告单价' prop='price' sortable='custom' width='100' align='center')
      template(slot-scope='scope')
        p {{ scope.row.price }} RMB
    el-table-column(label='操作' width='300' fixed='right' align='center')
      template(slot-scope='scope')
        el-button-group.operation-button
          el-button(:type='scope.row.health | handleHealth' size='mini' round @click='check(scope.row._id)' v-if='scope.row.healthStatus') 测
          el-button(:type='scope.row.health | handleHealth' size='mini' round @click='showRepairDialog(scope.row)' v-else) 修
          el-button(title='预览' size='mini' icon='el-icon-view' type='primary' @click='preview(scope.row)')
          el-button(v-if="hasEditAuth" title='修改' size='mini' icon='el-icon-edit' type='info' round @click='handleChange(scope.row)')
          // 状态，0=草稿；-1=退回修改；1=提交待审核；2=已经发布
          template(v-if='scope.row.status !== 1')
            Review(v-if='scope.row.status === 2' :single.sync='scope.row' title='所有元素驳回' url='/brief/review')
            Review(v-else :single.sync='scope.row' title='提交审阅' url='/brief/review')
          template(v-else)
            Review(:single.sync='scope.row' title='通过' type='report' url='/brief/review' @check='check' @sensitive="handleSensitive" ref="successReview")
            Review(:single.sync='scope.row' title='所有元素驳回' url='/brief/review')
            el-button(v-if='hasReviewAuth' title='仅报告驳回' round icon='el-icon-refresh' size='mini' type='danger' @click='review(scope.row)')
          el-button(v-if='scope.row.status === 2 && hasReviewAuth' title='仅报告驳回' round icon='el-icon-refresh' size='mini' type='danger' @click='review(scope.row)')
          el-button(title='删除' round size='mini' icon='el-icon-delete' type='danger' v-if='scope.row.status !== 2 && hasReviewAuth' @click='handlerDelete(scope.row)')
          el-button(title='下载' round size='mini' icon='el-icon-download' type='warning' @click='handleDownLoad(scope.row)')
  el-col(:span='24')
    el-pagination.pagination(background @current-change='handleCurrentChange' :current-page='findForm.currentPage' :page-size='GLOBAL.pageSize' layout='total, prev, pager, next' :total='total')
  el-dialog(title='健康检测' :visible.sync='isShowHealthDialog' width='600px')
    el-row(style='overflow: hidden')
      el-table(:data='currentHealth' style='width: 100%')
        el-table-column(prop='name' label='类型' width='80')
        el-table-column(prop='error' label='错误' show-overflow-tooltip width='250')
          template(slot-scope='scope')
            span(v-if='scope.row.error && scope.row.error.length > 0' v-html='scope.row.error.join("<br />")')
            i.el-icon-check(v-else style='color: #67C23A')
        el-table-column(prop='warning' label='警告' show-overflow-tooltip)
          template(slot-scope='scope')
            span(v-if='scope.row.warning && scope.row.warning.length > 0' v-html='scope.row.warning.join("<br />")')
            i.el-icon-check(v-else style='color: #67C23A')
      p Tips: 如果有错误的数据, 请点击修复进行修复数据, 如果是警告的数据, 代表该报告已审核通过, 但是元素有未通过审核的, 请重新执行审核流程
      el-button(type='primary' size='small' style='float: right; margin-top: 20px' @click='repair') 修复
      el-button(type='primary' size='small' style='float: right; margin-top: 20px; margin-right: 20px' @click='check(briefId)') 重新检测
  el-dialog(title='敏感词检测' :visible.sync='isShowSensitiveDialog' width='800px')
    el-row(style='overflow: hidden')
      el-table(:data='currentSensitive' style='width: 100%')
        el-table-column(prop='key' label='目录' width='100')
        el-table-column(prop='error' label='错误' show-overflow-tooltip)
          template(slot-scope='scope')
            span(v-html="scope.row.error.join('<br />')" )
      el-button(type='primary' size='small' style='float: right; margin-top: 20px' @click='close') 前往修改
      el-button(size='small' style='float: right; margin-top: 20px; margin-right: 20px' @click='handleReview()') 仍然提交
</template>

<script>
import apis from '@/apis/brief'
import FrostIndustry from '@/components/industry'
import Enum from '@/apis/enum'
import csv from '@/apis/csv'
import { parseTime } from '@/javascripts/time'
import Review from '@/components/Review'
import passport from '@/javascripts/passport'

export default {
  components: { FrostIndustry, Review },
  data () {
    return {
      briefId: -1,

      pickerOptions: Enum.pickerOptions,
      KIND: [
        { label: '全部', value: -1 },
        { label: '竖版', value: 0 },
        { label: '横版', value: 1 }
      ],
      // PDF: [
      //   { label: '全部', value: -1 },
      //   { label: '有', value: 1 },
      //   { label: '无', value: 0 }
      // ],
      findForm: {
        writtenDate: '',
        title: '',
        industryId: [],
        status: [],
        briefType: [],
        kind: -1,
        checkList: [],
        // freeStatus: ['isfree', 'nofree'],
        releasedStatus: ['isreleased', 'noreleased'],
        sortwhere: { order: 'descending', prop: 'createdAt' },
        currentPage: 1
      },
      total: 0,
      options: Enum.STATUS,
      briefType: Enum.BRIEF_ATTRIBUTE,
      tableData: [],
      loading: true,
      isShowCondition: false,
      isShowHealthDialog: false,
      isShowConditionText: '更多',
      currentHealth: [],
      health: [
        { name: '目录', type: 'outline' },
        { name: '段落', type: 'section' },
        { name: '幻灯片', type: 'slide' },
        { name: '元素', type: 'element' },
        { name: '数说', type: 'size' },
        { name: '图说', type: 'ill' },
        { name: '专家说', type: 'quote' },
        { name: '表说', type: 'table' }
      ],
      isShowSensitiveDialog: false,
      currentSensitive: []
    }
  },
  methods: {
    close () {
      this.isShowSensitiveDialog = false
    },
    handleSensitive (data) {
      this.currentSensitive = data
      this.isShowSensitiveDialog = true
    },
    handleReview () {
      this.$refs.successReview.handleReview()
      this.close()
    },
    // 导出全部标签
    exportLabels () {
      apis.exportLabels().then(async res => {
        // console.log(res)
        await csv.exportData(res.data, { header: ['标签', '数量'] }, '报告标签.csv')
      })
    },
    // 是否显示查询条件
    showMoreCondition () {
      if (this.isShowCondition) {
        this.isShowCondition = false
        this.isShowConditionText = '更多'
      } else {
        this.isShowCondition = true
        this.isShowConditionText = '收起'
      }
    },
    // 搜索
    search () {
      this.findForm.currentPage = 1
      this.findReport()
    },
    // 查询方法
    findReport () {
      this.loading = true
      apis.getReportPage({ queryParams: this.findForm }).then(r => {
        if (r.errCode !== 0) return this.$message({ type: 'warning', message: '' + r.msg })
        if (r.data) {
          this.total = r.data.count
          for (const item of r.data.data) {
            item.healthStatus = this.checkHealthStatus(item.health)
            if (item.health) {
              let health = JSON.parse(JSON.stringify(this.health))
              health = health.map(value => ({ ...value, ...item.health[value.type] }))
              item.health = health
            }
          }
          this.tableData = r.data.data
          this.loading = false
        }
      }).catch(err => {
        this.$message({ message: err, type: 'error' })
      })
    },
    // 报告分页切换
    handleCurrentChange (val) {
      this.findForm.currentPage = val
      this.findReport()
    },
    // 报告列表排序
    tableSortChange (column) {
      const { order, prop } = column
      this.findForm.sortwhere = { order, prop }
      this.findReport()
    },
    // 行业筛选条件选择
    industryId (e) {
      this.findForm.industryId = e.length === 0 ? [] : e
    },
    // 预览报告
    preview (e) {
      if (e.kind === 0) {
        const routerUrl = this.$router.resolve({ name: 'preview', query: { id: e._id } })
        window.open(routerUrl.href, '_blank')
      } else {
        const routerUrl = this.$router.resolve({ name: 'previewSlide', query: { id: e._id } })
        window.open(routerUrl.href, '_blank')
      }
    },
    // 打开报告录入的页面
    handleChange (e) {
      const routerUrl = this.$router.resolve({ name: 'EditReportBrief', query: { id: e._id } })
      window.open(routerUrl.href, '_blank')
    },
    // 删除报告
    handlerDelete (brief) {
      this.$confirm('此操作将删除该报告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.deleteBrief({ id: brief._id, kind: brief.kind }).then(res => {
          if (res.data.errcode === 0) {
            this.$message({ type: 'success', message: '删除成功' })
            this.findReport()
          }
        })
      })
    },
    // 查询报告 总页数/总字数
    totalCount (brief) {
      apis.getCount({ id: brief._id, kind: brief.kind }).then(res => {
        if (res.errCode === 0) {
          this.$message({ type: 'success', message: '查询成功' })
          this.findReport()
        }
      })
    },
    // 驳回报告
    review (row) {
      apis.updateBrief({ _id: row._id, status: -1 }, 'put').then(res => {
        this.handleResult(res, '仅驳回报告', () => {
          this.$set(row, 'status', -1)
        })
      }).catch(err => {
        this.$message({ type: 'error', message: err })
      })
    },
    // 检测报告是否健康
    check (briefId) {
      apis.checkReport({ id: briefId }).then(res => {
        this.handleResult(res, '健康检测', () => {
          const flag = this.checkHealthStatus(res.data)
          const briefObj = this.tableData.find(item => item._id === briefId)
          this.$set(briefObj, 'healthStatus', flag)
          this.$set(briefObj, 'health', res.data)
          let health = JSON.parse(JSON.stringify(this.health))
          health = health.map(value => ({ ...value, ...res.data[value.type] }))
          briefObj.health = health
          this.currentHealth = health
          if (!flag) this.showRepairDialog(briefObj)
        })
      })
    },
    // 检测一个健康对象health中是否有错误的对象 true: 无错误, false: 有错误的对象
    checkHealthStatus (health) {
      let flag = true
      if (health) {
        for (const key in health) {
          const error = health[key].error.length === 0
          let warning = true
          if (health[key].warning) {
            warning = health[key].warning.length === 0
          }
          flag = error && warning
          if (!flag) break
        }
      }
      return flag
    },
    // 显示修复的弹框
    showRepairDialog (data) {
      this.currentHealth = data.health
      this.briefId = data._id
      this.isShowHealthDialog = true
    },
    /**
     * 张雨生 2020/01/20
     * 健康修复
     * @param brief 报告对象
     * @returns health对象
     */
    repair () {
      apis.repairReport({ id: this.briefId }).then(res => {
        this.handleResult(res, '修复', () => {
          const brief = this.tableData.find(item => item._id === this.briefId)
          const flag = this.checkHealthStatus(res.data)
          this.$set(brief, 'healthStatus', flag)
          this.$set(brief, 'health', res.data)
          this.isShowHealthDialog = false
        })
      })
    },
    handleDownLoad (row) {
      apis.getBriefLogList({ id: row._id }).then(response => {
        if (response.errCode !== 0) return this.$message.error(response.msg)
        if (!response.data || !response.data.length) return this.$message.error('无可下载附件')
        response.data.sort((prev, next) => {
          return new Date(next.updatedAt).getTime() - new Date(prev.updatedAt).getTime()
        })
        const fileData = response.data[0]
        apis.downloadLogFile({ url: fileData.originalFile, title: row.title }).then(res => {
          if (res.errCode !== 0) return this.$message.error(res.msg)
          if (!res.data) return this.$message.error('未找到文件')
          const url = res.data
          const a = document.createElement('a')
          a.download = row.title
          a.href = url
          a.click()
        }).catch(err => {
          this.$message({ type: 'error', message: '下载文件失败!' + err })
        })
      })
    }
  },
  computed: {
    hasEditAuth () {
      return passport.checkAuth([Enum.AUTH.REPORT_REVIEW, Enum.AUTH.REPORT_EDIT])
    },
    hasReviewAuth () {
      return passport.checkAuth([Enum.AUTH.REPORT_REVIEW])
    }
  },
  mounted () {
    this.findReport()
    const that = this
    document.onkeypress = function (e) {
      const keycode = document.all ? event.keyCode : e.which
      if (keycode === 13) {
        that.search()
      }
    }
  },
  filters: {
    handleHealth (val) {
      if (!val) {
        return 'info'
      } else {
        let error = []
        let warning = []
        for (const key in val) {
          error = error.concat(val[key].error)
          if (val[key].warning) {
            warning = warning.concat(val[key].warning)
          }
        }
        if (error.length !== 0) return 'danger'
        if (warning.length !== 0) return 'warning'
        return 'success'
      }
    },
    changeData: function (val) {
      if (!val) return '暂无日期'
      var date = new Date(val)
      return parseTime(date, '{y}-{m}-{d}')
    },
    getIndustry: function (val) {
      let str = ''
      for (const i in val) {
        str = str + val[i] + '  '
      }
      return str
    },
    formatBriefType: function (val) {
      const briefTypeMap = new Map([[0, '短'], [1, '普'], [2, '深'], [3, '简'], [4, '白'], [5, '推']])
      const briefType = briefTypeMap.get(val)
      return `[${briefType}]`
    }
  }
}
</script>

<style>
.health-popover {
  height: 60vh !important;
}

.el-button-group.operation-button .el-button--mini {
  padding: 5px 10px;
}

.hide {
  display: none;
}
</style>